module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"IN_STOCK":"En stock"},"en":{"IN_STOCK":"In stock"},"es":{"IN_STOCK":"En stock"},"de":{"IN_STOCK":"Lieferbar","unavailable":"Dieser Artikel ist derzeit leider nicht erhältlich."},"it":{"IN_STOCK":"Disponibile"},"nl":{"IN_STOCK":"Op voorraad"},"pt":{"IN_STOCK":"Em stock"}}')
  delete Component.options._Ctor
}
